import { render, staticRenderFns } from "./AnnouncementsPastDialog.vue?vue&type=template&id=31d5a6b2&scoped=true&"
import script from "./AnnouncementsPastDialog.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsPastDialog.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsPastDialog.vue?vue&type=style&index=0&id=31d5a6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d5a6b2",
  null
  
)

export default component.exports